// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { ScoresService } from '@client/app/modules/score/services/scores/scores.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import {
    AccessibilityDoughnutChartService,
} from '@client/app/blocks/service/charts/accessibility-doughnut-chart.service';
import {
    AccessibilityLineChartServiceFactory,
} from '@client/app/blocks/service/charts/accessibility-line-chart/accessibility-line-chart.service';

@Component({
    selector: 'accessibility-dashboard-summary',
    standalone: false,
    template: `
        <div class="row justify-content-center">
            <div class="mt-6">
                <div class="row">
                    <div class="col mb-2">
                        <accessibility-dashboard-doughnut
                            [data]="doughnutData"
                            [options]="doughnutOptions">
                        </accessibility-dashboard-doughnut>
                    </div>
                    <div class="col d-flex align-items-center justify-content-center mb-2" *ngIf="allowVerticalAverage && isVerticalDataSet">
                        <mon-vertical-score
                            [monChartValue]="verticalAverage"
                            [monTitle]="texts.averageTitle"
                            [monTooltipText]="verticalTooltipText"
                            [monLabels]="[texts.succeeds, texts.errors]"
                        ></mon-vertical-score>
                    </div>
                </div>
            </div>
            <div class="col-48">
                <accessibility-dashboard-notifications [accessibilityChecks]="accessibilityChecks"
                                                      [history]="history"
                                                      [selectedObs]="selectedObs"
                                                      [summary]="summary">
                </accessibility-dashboard-notifications>
            </div>
            <div class="col-48">
                <mon-spinner [progress]="progress">
                    <accessibility-summary-line-chart [data]="lineData"
                                                      [options]="lineOptions"
                                                      [history]="history">
                    </accessibility-summary-line-chart>
                </mon-spinner>
            </div>
        </div>
    `,
})
export class AccessibilityDashboardSummaryComponent implements OnInit {
    @Input() history: any;
    @Input() summary: any;
    @Input() accessibilityChecks: any;
    @Input() selectedObs: any;
    @Input() progress: any;

    allowVerticalAverage = false;
    isVerticalDataSet = false;
    verticalAverage = 0;
    verticalTooltipText = '';
    selectedDate: any = null;
    doughnutData: any;
    doughnutOptions: any;
    lineData: any;
    lineOptions: any;
    texts: any = {};

    constructor (
        private demoHasAccessService: DemoHasAccessService,
        private activeFeatureService: ActiveFeatureService,
        private scoresService: ScoresService,
        private translateService: TranslateService,
        private accessibilityDoughnutChartService: AccessibilityDoughnutChartService,
        private accessibilityLineChartServiceFactory: AccessibilityLineChartServiceFactory,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.selectedDate = null;
        this.selectedObs.subscribe((val: any) => {
            this.setupLineChart(val);
            this.setupDoughnutChart(val);
        });

        const isDemoAccount = this.demoHasAccessService.isDemoAccount();
        if (isDemoAccount) {
            this.allowVerticalAverage = true;
            this.setVerticalData(this.scoresService.getAccessibilityDemoData());
        } else {
            this.allowVerticalAverage = this.activeFeatureService.isFeatureActive('monsido_score');
            if (this.allowVerticalAverage) {
                this.scoresService.getAverageData('accessibility').then((data: any) => this.setVerticalData(data));
            }
        }

        this.texts = {
            averageTitle: this.scoresService.getDefaultTitle(),
            succeeds: this.translateService.getString('Succeeds'),
            errors: this.translateService.getString('Errors'),
        };
    }

    private setupDoughnutChart (val: any): void {
        const chartService = this.accessibilityDoughnutChartService.init(this.summary, this.accessibilityChecks);
        this.doughnutData = chartService.getData(val, '');
        this.doughnutOptions = chartService.getOptions(val);

        this.doughnutOptions.tooltips = {
            enabled: true,
            callbacks: {
                label: (tooltipItem: any) => {
                    if (tooltipItem.index === 0) {
                        return this.texts.succeeds;
                    }
                    return this.texts.errors;
                },
            },
        };
    }

    private setupLineChart (val: any): void {
        const service = this.accessibilityLineChartServiceFactory.createInstance();
        service.init();
        service.setup().then(() => {
            this.progress = service.getOption(val, this.history).then((options: any) => {
                this.lineOptions = options;
                this.lineData = service.getData(this.history, val);
            }, () => {});
        }, () => {});
    }

    getSelectedScanDateName (): string {
        if (this.selectedDate === null || typeof this.selectedDate !== 'object') {
            return this.translateService.getString('No date range selected');
        }
        return this.selectedDate.name;
    }

    private setVerticalData (data: any): void {
        const defaultTooltip = this.scoresService.getDefaultTooltip();
        if (this.texts) {
            this.texts.verticalName = data.name;
        }
        this.verticalTooltipText = defaultTooltip + ' ' + data.name;
        this.verticalAverage = data.score;
        this.isVerticalDataSet = true;
    }
}
